import { useEffect, useRef } from 'react';
import { loadScript } from '/src/utils';
import { sentryCaptureException } from '/src/services';

const cloudflareRecaptcha = () => {
    const { turnstile } = window;

    if (turnstile) {
        return new Promise(resolve => resolve());
    }

    return loadScript('https://challenges.cloudflare.com/turnstile/v0/api.js');
};

const cloudflareGetRecaptchaToken = () => {
    const { turnstile } = window;

    if (!!turnstile) {
        return turnstile.getResponse();
    }

    return null;
};

const cloudflareResetRecaptcha = widgetId => {
    const { turnstile } = window;

    if (turnstile) {
        turnstile.reset(widgetId);
    }
};

const cloudflareUseRecaptcha = (cloudflareSiteKey, id = '#cf-turnstile') => {
    const ref = useRef(null);

    const getWidgetId = () => ref.current;
    const resetWidgetId = () => {
        ref.current = null;
    };

    useEffect(() => {
        cloudflareRecaptcha().then(() => {
            const { turnstile } = window;

            ref.current = turnstile.render(id, {
                sitekey: cloudflareSiteKey,
                theme: 'light',
                size: 'flexible',
                'error-callback': () => cloudflareResetRecaptcha(getWidgetId()),
            })
        }).catch(errors => {
            sentryCaptureException(errors);
        });

        return () => {
            const { turnstile } = window;

            if (getWidgetId()) {
                turnstile.remove(getWidgetId());
                resetWidgetId();
            }
        };
    }, []);

    return {
        cloudflareResetRecaptcha: () => cloudflareResetRecaptcha(getWidgetId())
    }
};

export {
    cloudflareUseRecaptcha,
    cloudflareGetRecaptchaToken,
}
